import { render, staticRenderFns } from "./text-fragment.vue?vue&type=template&id=0885ba72&scoped=true&"
import script from "./text-fragment.vue?vue&type=script&lang=ts&"
export * from "./text-fragment.vue?vue&type=script&lang=ts&"
import style0 from "./text-fragment.vue?vue&type=style&index=0&id=0885ba72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0885ba72",
  null
  
)

export default component.exports